module.exports = __webpack_public_path__ + "img/img9.0587a6a0.png";